import React from 'react';
import PropTypes from 'prop-types';
import { StyledText } from '../styles';

export const AtomicText = ({
  element,
  mobileDesign,
  tabletDesign,
  desktopDesign,
  children,
  className,
  truncateLines
}) => (
  <StyledText
    as={element}
    mobileDesign={mobileDesign}
    tabletDesign={tabletDesign}
    desktopDesign={desktopDesign}
    className={className || 'text'}
    truncateLines={truncateLines}
  >
    {children}
  </StyledText>
);

AtomicText.propTypes = {
  element: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
  mobileDesign: PropTypes.shape({
    [PropTypes.string]: PropTypes.any
  }),
  tabletDesign: PropTypes.shape({
    [PropTypes.string]: PropTypes.any
  }),
  desktopDesign: PropTypes.shape({
    [PropTypes.string]: PropTypes.any
  }),
  className: PropTypes.string,
  truncateLines: PropTypes.number
};

AtomicText.defaultProps = {
  mobileDesign: {},
  tabletDesign: {},
  desktopDesign: {},
  className: undefined,
  truncateLines: undefined
};
